import React from 'react';
import Head from 'next/head';
import { LegalContent } from '@components/Shared/LegalPrivacy/LegalAndPrivacy';
import { LegalStyles } from '@components/Shared/LegalPrivacy/LegalAndPrivacy.styled';

const Legal = () => {
  return (
    <LegalStyles className="standard">
      <Head>
        <title>Legal | Clayton Homes</title>
        <meta
          name="description"
          content="We respect your privacy and are committed to providing a transparent notice of our Legal statement."
        />
      </Head>
      <h1>Legal</h1>
      <LegalContent />
    </LegalStyles>
  );
};

export default Legal;
